
<div class="collapse">
  <button @click="visible = !visible">
    <slot v-if="$slots.header" name="header" />

    <template v-else>
      <h4 v-html="title" />

      <icon :name="visible ? 'expand_less' : 'expand_more'" />
    </template>
  </button>

  <div v-show="visible" class="content">
    <slot />
  </div>
</div>
